import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';

const LEGAL_SECTIONS = [
  'editor', 'activity', 'hosting', 'credit', 'ip', 'data', 'cookies', 'liability', 'law'
];

const MentionsLegales = () => {
  const { t } = useLanguage();

  return (
    <>
      <SEO
        title={t('seo.legal.title')}
        description={t('seo.legal.description')}
        url="/mentions-legales"
      />
      <div className="container mx-auto px-4 pt-28 pb-16 min-h-screen max-w-3xl">
        <h1 className="text-4xl font-extrabold text-primary mb-2">{t('legal.title')}</h1>
        <div className="h-1 w-20 bg-primary mb-12" />

        {LEGAL_SECTIONS.map((section) => (
          <section key={section} className="mb-10">
            <h2 className="text-xl font-bold text-primary mb-3">{t(`legal.${section}.title`)}</h2>
            <div className="space-y-3 text-base-content/80 leading-relaxed">
              {section === 'editor' ? (
                <div dangerouslySetInnerHTML={{ __html: t(`legal.${section}.text`) }} />
              ) : (
                <p>{t(`legal.${section}.text`)}</p>
              )}
              {section === 'editor' && (
                <p>
                  {'Adresse électronique : '}
                  <a href="mailto:lamarmottejoyeuse@gmail.com" className="text-primary hover:underline">
                    lamarmottejoyeuse@gmail.com
                  </a>
                </p>
              )}
              {section === 'hosting' && (
                <p>
                  <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                    www.ovhcloud.com
                  </a>
                </p>
              )}
            </div>
          </section>
        ))}
      </div>
    </>
  );
};

export default MentionsLegales;
